<template>
  <div>
    <div class="p-grid">
      <div class="p-col-fixed" style="width:200px;" id="divImagem">
        <div style="width: 150px; height: 150px;" class="p-mb-2" id="divFoto">
          <img src="/perfilsemfoto.png" alt="Foto Perfil" ref="imgFotoPerfil" style="width: 100%; height: 100%; object-fit: cover;"/>
        </div>        
      </div>
      <div class="p-col">	
        <div class="p-fluid p-formgrid p-grid" v-if="!semDados">
          <div class="p-field p-col-12 p-md-2">
              <label>Período</label>
              <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" :yearNavigator="true"
                :yearRange="rangeData" :locale="localeCalendarBR"/>				
          </div>        
          <div class="p-field p-col-0">
              <label style="color:#ffffff">.</label>  
              <Button label="Atualizar" icon="pi pi-refresh" @click="atualizarDadosTela"/>
          </div>
          <div class="p-field p-col-0 p-ml-2" v-if="permissaoEditar">
              <label style="color:#ffffff">.</label>  
              <SplitButton label="Ações" icon="pi pi-plus" :model="maisAcoes"></SplitButton>
          </div>          
          <div class="p-field p-col-0 p-ml-2" style="margin-top: 12px;">
            <IKMonitoramentoDocumentos ref="ikMonitoramentoDocumentos"/>   
          </div>                   
        </div>
        <div class="p-fluid p-formgrid p-grid" v-if="!semDados">
          <div class="p-field p-col-12">
             <label class="p-text-bold" style="color: #808080">Nome:&nbsp;&nbsp;</label><label>{{ nome }} </label>&nbsp;&nbsp;
             <label class="p-text-bold" style="color: #808080">Crachá:&nbsp;</label><label>{{ cracha }} </label><br/>
             <label class="p-text-bold" style="color: #808080">Centro de Custo:&nbsp;&nbsp;</label><label>{{ nomeCentroCusto }} </label>                    	
          </div>                       
        </div>
      </div>
    </div>
    <TabView>
      <TabPanel header="Detalhes" class="p-mt-2">
        <DataTable :value="pontos" :autoLayout="true" class="p-datatable-sm p-datatable-striped">          
          <Column field="dia" header="Data">
            <template #body="slotProps">						
              <div v-html="corDataDiaSemana(slotProps.data)" :class="diaComPendencia(slotProps.data)"></div> 
            </template>
          </Column>
          <Column field="descricaoMarcacoes" header="Marcações"></Column>
          <Column field="entrada1" header="1ª Ent">
            <template #body="slotProps">
            {{ slotProps.data.entrada1 | horaCurtoPtBR }}
            </template>
          </Column>
          <Column field="saida1" header="1ª Sai">
            <template #body="slotProps">
            {{ slotProps.data.saida1 | horaCurtoPtBR }}
            </template>
          </Column>
          <Column field="entrada2" header="2ª Ent">
            <template #body="slotProps">
            {{ slotProps.data.entrada2 | horaCurtoPtBR }}
            </template>
          </Column>
          <Column field="saida2" header="2ª Sai">
            <template #body="slotProps">
            {{ slotProps.data.saida2 | horaCurtoPtBR }}
            </template>
          </Column>
          <Column field="entrada3" header="3ª Ent" v-if="!esconderTeceiroPar">
            <template #body="slotProps">
            {{ slotProps.data.entrada3 | horaCurtoPtBR }}
            </template>
          </Column>
          <Column field="saida3" header="3ª Sai" v-if="!esconderTeceiroPar">
            <template #body="slotProps">
            {{ slotProps.data.saida3 | horaCurtoPtBR }}
            </template>
          </Column>	
          <Column field="jornadaFormatada" header="Jornada"></Column>
          <Column field="horasFaltantesFormatada" header="H.F."></Column>	
          <Column field="codigoHorario" header="CH"></Column>
          <Column field="ocorrenciaMarcacoes" header="Ocorrência"></Column>
          <Column field="descricaoEventos" header="Observação">
            <template #body="slotProps">
              <div v-html="slotProps.data.descricaoEventos"></div> 
            </template>
          </Column>
          <Column v-if="permissaoEditar">
            <template #body="slotProps">
              <SplitButton label="Ações" class="p-button-secondary" :model="acoesPontoDia(slotProps.data)" appendTo="body" ></SplitButton>						
            </template>
          </Column>
        </DataTable>
        <ControleFolga ref="modalControleFolga" :callback="calcularPeriodoEditado"/>
        <ControleMoverMarcacao ref="modalControleMoverMarcacao" :callback="calcularPeriodoEditado"/>
        <ControleJustificativa ref="modalControleJustificativa" :callback="calcularPeriodoEditado"/>
        <ControleMudancaHorario ref="modalControleMudancaHorario" :callback="calcularPeriodoEditado"/>
        <ControleAjusteParcial ref="modalControleAjusteParcial" :callback="calcularPeriodoEditado"/>
        <ControleEditarMarcacoes ref="modalControleEditarMarcacoes" :callback="calcularPeriodoEditado"/>
        <ControleFeriadoExcluido ref="modalControleFeriadoExcluido" :callback="calcularPeriodoEditado"/>
        <SolicitacoesPendentes ref="solicitacoesPendentes" />
      </TabPanel>
      <TabPanel header="Resumo" class="p-mt-3">
        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <Panel header="Jornada">
              <DataTable :value="totaisJornadas" :autoLayout="true" class="p-datatable-sm p-datatable-striped">
                <Column field="descricao" header="Descrição"></Column>
                <Column field="dias" header="Dias"> </Column>
                <Column field="total" header="Total"> </Column>
              </DataTable>                
            </Panel>
          </div> 
          <div class="p-col-12 p-md-6">
            <Panel header="Horas Extras">
              <DataTable :value="horasExtrasEventos" :autoLayout="true" class="p-datatable-sm p-datatable-striped">
                <Column field="descricao" header="Descrição"></Column>                  
                <Column field="valor" header="Total"> </Column>
              </DataTable>
            </Panel>
          </div> 
          <div class="p-col-12 p-md-6">
            <Panel header="Evento">
              <DataTable :value="outrosEventos" :autoLayout="true" class="p-datatable-sm p-datatable-striped">
                <Column field="descricao" header="Descrição"></Column>
                <Column field="dias" header="Dias"> </Column>
                <Column field="valor" header="Total"> </Column>
              </DataTable>
            </Panel>
          </div> 
          <div class="p-col-12 p-md-6">
            <Panel header="Banco de Horas">
              <DataTable :value="totaisBancoHoras" :autoLayout="true" class="p-datatable-sm p-datatable-striped">
                <Column field="descricao" header="Descrição"></Column>                 
                <Column field="valor" header="Total">
                  <template #body="slotProps">						
                    <div v-html="corItensSumario(slotProps.data.valor)"></div> 
                  </template>
                </Column>
              </DataTable>
            </Panel>
          </div> 
        </div>          
      </TabPanel>
    </TabView>

    <Dialog :visible.sync="exibirDialogFecharPeriodo" header="Confirmar" :modal="true" :style="{width: '450px'}">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
        <span><b>Atenção!</b></span><br/>
        <br/>
        <p>
          Tenha certeza de ter realizado todos os ajustes no ponto. Após o fechamento, somente o <span class="p-text-bold">Administrador</span> fará o desbloqueio.
        </p>
        <p>
          A data do período não poderá ser modificada.
        </p>
        <p>
          Todos os dias serão marcados como concluídos.
        </p>
      </div>
      <template #footer>
        <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogFecharPeriodo = false"/>
        <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="fecharPeriodo" />
      </template>
    </Dialog>

    <Dialog :visible.sync="exibirDialogAbrirPeriodo" header="Confirmar" :modal="true" :style="{width: '450px'}">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
        <span><b>Abrir período?</b></span><br/>             
      </div>
      <template #footer>
        <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogAbrirPeriodo = false"/>
        <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="abrirPeriodo" />
      </template>
    </Dialog>

    <Dialog :visible.sync="exibirDialogConcluirPeriodo" header="Confirmar" :modal="true" :style="{width: '450px'}">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
        <span><b>Atenção!</b></span><br/>
        <br/>
        <p>
          A data do período não poderá ser modificada!
        </p>
        <p>
          Todos os dias serão marcados como concluídos.
        </p>          
      </div>
      <template #footer>
        <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConcluirPeriodo = false"/>
        <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="concluirPeriodo" />
      </template>
    </Dialog>

    <Dialog :visible.sync="exibirDialogExclurOcorrencias" header="Confirmar" :modal="true" :style="{width: '450px'}">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
        <span><b>Atenção!</b></span><br/>
        <br/>
        <p>
          Deseja realmente excluir as ocorrências para esse dia?
        </p>                   
      </div>
      <template #footer>
        <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogExclurOcorrencias = false"/>
        <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluirOcorrencia" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import SolicitacoesPendentes from '@/components/pages/movimento/controlePonto/SolicitacoesPendentes.vue';
import ControleFolga from '@/components/pages/movimento/controlePonto/ControleFolga.vue';
import ControleMoverMarcacao from '@/components/pages/movimento/controlePonto/ControleMoverMarcacao.vue';
import ControleJustificativa from '@/components/pages/movimento/controlePonto/ControleJustificativa.vue';
import ControleMudancaHorario from '@/components/pages/movimento/controlePonto/ControleMudancaHorario.vue';
import ControleAjusteParcial from '@/components/pages/movimento/controlePonto/ControleAjusteParcial.vue';
import ControleEditarMarcacoes from '@/components/pages/movimento/controlePonto/ControleEditarMarcacoes.vue';
import ControleFeriadoExcluido from '@/components/pages/movimento/controlePonto/ControleFeriadoExcluido.vue';
import IKMonitoramentoDocumentos from '@/components/template/IKMonitoramentoDocumentos';
import ControlePontoService from '@/service/ControlePontoService';
import { exibirMensagem, localeCalendarBR, FOTO_PERFIL_PADRAO } from '@/global';
import FuncionarioService from '@/service/FuncionarioService';
import { mapGetters } from 'vuex';

export default {
  funcionarioService: null,
  controlePontoService: null,
  data() {
      return {  
        permissaoEditar: false,
        exibirDialogExclurOcorrencias: false,
        exibirDialogConcluirPeriodo: false,
        exibirDialogAbrirPeriodo: false,
        exibirDialogFecharPeriodo: false,
        exibirModalFolga: false,
        esconderTeceiroPar: false,
        resumoGeral: null,
        totaisJornadas: [],
        outrosEventos: [],
        horasExtrasEventos: [],
        totaisBancoHoras: [],
        cracha: '',
        nome:  '',
        nomeCentroCusto: '',
        pontos: [],
        mesAno: new Date(),
        rangeData: '',
        applicarCalculos: true,        
        maisAcoes: [],
        pontoOcorrenciaExcluir: null,
        semDados: true,
        localeCalendarBR: localeCalendarBR,
        fotoPerfil: FOTO_PERFIL_PADRAO,       
        eventoSelecionado: '',
        dataUltimoCliqueCalc: null,        
        intervaloMaxioCliqueCalc: 3000
      }
  },
  methods: {
      ...mapGetters('sessao', ['getDadosRequisicao', 'getPermissoes']),
      ...mapGetters('funcionario', ['getDadosMarcacoes']),
      iniciar() {
        let dados = this.getDadosMarcacoes();          
        if(dados != null) {
          this.semDados = false;
          this.mesAno = dados.mesAno;
          this.nome = dados.funcionario.nome;  
          this.nomeCentroCusto = dados.funcionario.centroCusto.nome;
          this.cracha = dados.funcionario.crachaFormatado;    
          setTimeout(() => {
            this.$refs.imgFotoPerfil.src = dados.funcionario.fotoPerfil ? dados.funcionario.fotoPerfil : '/perfilsemfoto.png';
          }, 1000);
          this.buscarResumo(); 
        }                
      },
      atualizarDadosTela() {
        if(this.dataUltimoCliqueCalc == null) {
          this.buscarResumo();
        } else {
          const timeClick = new Date().getTime();
          const diffTimeClick = timeClick - this.dataUltimoCliqueCalc.getTime();
          if(diffTimeClick >= this.intervaloMaxioCliqueCalc) {          
            this.buscarResumo();
          }
        }          
        this.dataUltimoCliqueCalc = new Date();
      },     
      atualizar() {
        this.applicarCalculos = true;
        this.calcularPonto();        
      },      
      calcularPeriodoEditado(dataInicio, dataFinal) {
        let dados = this.getDadosMarcacoes();                         
        let requisicao = {
          mes: this.mesAno.getMonth()+1,
          ano: this.mesAno.getFullYear(),
          dataInicio: dataInicio,
          dataFinal: dataFinal,
          cnpj: {...dados.cnpj},
          funcionario: {...dados.funcionario},          
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };
        this.controlePontoService.calcularPeriodoEditado(requisicao)
        .then(resp => {
          this.resumoGeral = resp.data;              
          this.carregarResumo();                   
        })
        .catch(erro => {exibirMensagem(this, erro)});      
      },
      buscarResumo() {      
        let dados = this.getDadosMarcacoes();              
        let requisicao = {
          mes: this.mesAno.getMonth()+1,
          ano: this.mesAno.getFullYear(),
          cnpj: {...dados.cnpj},
          funcionario: {...dados.funcionario},
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };       
        this.controlePontoService.buscarResumoFuncionario(requisicao)
          .then(resp => {
              this.resumoGeral = resp.data;              
              this.carregarResumo();                   
          })
          .catch(erro => {exibirMensagem(this, erro)});          
      },    
      calcularPonto() {      
        let dados = this.getDadosMarcacoes();              
        let requisicao = {
          mes: this.mesAno.getMonth()+1,
          ano: this.mesAno.getFullYear(),
          cnpj: {...dados.cnpj},
          funcionario: {...dados.funcionario},
          applicarCalculos: this.applicarCalculos,
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };       
        this.controlePontoService.buscarCalcularMarcacoesFuncionario(requisicao)
          .then(resp => {
              this.resumoGeral = resp.data;              
              this.carregarResumo();                   
          })
          .catch(erro => {exibirMensagem(this, erro)});          
      },
      carregarResumo() {
        this.pontos = this.resumoGeral.pontos;              
        let qtd = 0;
        this.pontos.forEach(ponto => {
          if(ponto.entrada3 == null && ponto.saida3 == null) {
            qtd++;
          }
        });
        if(this.pontos.length == qtd) {
          this.esconderTeceiroPar = true;
        }
        this.totaisJornadas = [];
        this.totaisBancoHoras = [];
        let sumario = this.resumoGeral.sumario;  
        this.totaisJornadas.push({descricao: 'Horas trabalhadas', dias: sumario.diasTrabalhados, total: sumario.jornada});
        this.totaisJornadas.push({descricao: 'Horas trabalhadas + abono', dias: sumario.diasTrabalhados, total: sumario.jornadaEAbono});
        this.outrosEventos = sumario.outrosEventos;
        this.horasExtrasEventos = sumario.horasExtrasEventos;
        this.totaisBancoHoras.push({descricao: 'Saldo anterior (A)', valor: sumario.saldoAnteriorBH}); 
        this.totaisBancoHoras.push({descricao: 'Saldo lançado (B)', valor: sumario.saldoDebitoLancado}); 
        this.totaisBancoHoras.push({descricao: 'Saldo lançado (C)', valor: sumario.saldoCreditoLancado}); 
        this.totaisBancoHoras.push({descricao: 'Créditos', valor: sumario.creditosBH}); 
        this.totaisBancoHoras.push({descricao: 'Créditos + A + B + C', valor: sumario.totalCreditos}); 
        this.totaisBancoHoras.push({descricao: 'Débitos', valor: sumario.debitosBH}); 
        this.totaisBancoHoras.push({descricao: 'Saldo final', valor: sumario.saldoFinal});     
        let periodoFechado = false;
        if(typeof this.resumoGeral.periodoFechamento !== undefined) {
          periodoFechado = this.resumoGeral.periodoFechamento.fechado;
        }
        this.acoesGerais(periodoFechado);
      },
      fecharPeriodo() {
        let dados = this.getDadosMarcacoes();              
        let requisicao = {
          mes: this.mesAno.getMonth()+1,
          ano: this.mesAno.getFullYear(),
          cnpj: {...dados.cnpj},
          funcionario: {...dados.funcionario},
          applicarCalculos: this.applicarCalculos,
          fecharPeriodo: true,
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };       
        this.controlePontoService.fecharPeriodo(requisicao)
        .then(resp => {
          exibirMensagem(this, resp);
          this.exibirDialogFecharPeriodo = false;
          if(dados.cnpj) {
            this.buscarResumo(); 
          } else {
            this.calcularPonto();
          }                            
        })
        .catch(erro => {
          exibirMensagem(this, erro);
        });        
      },
      abrirPeriodo() {             
        let requisicao = {          
          idPeriodoFechamento: this.resumoGeral.periodoFechamento.id,
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };       
        this.controlePontoService.abrirPeriodo(requisicao)
        .then(resp => {
          exibirMensagem(this, resp);
          this.exibirDialogAbrirPeriodo = false;
          this.acoesGerais(false);                               
        })
        .catch(erro => {exibirMensagem(this, erro)});   
      },
      concluirPeriodo() {
        let dados = this.getDadosMarcacoes();              
        let requisicao = {
          mes: this.mesAno.getMonth()+1,
          ano: this.mesAno.getFullYear(),
          cnpj: {...dados.cnpj},
          funcionario: {...dados.funcionario},
          applicarCalculos: this.applicarCalculos,
          fecharPeriodo: false,
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };       
        this.controlePontoService.fecharPeriodo(requisicao)
        .then(resp => {
          exibirMensagem(this, resp);
          this.exibirDialogConcluirPeriodo = false;
          if(dados.cnpj) {
            this.buscarResumo(); 
          } else {
            this.calcularPonto();
          }                     
        })
        .catch(erro => {
          exibirMensagem(this, erro);
        });
      },
      excluirOcorrencia() {   
        let dados = this.getDadosMarcacoes();                   
        let requisicao = {
          diaPonto: this.pontoOcorrenciaExcluir.dia,
          idFuncionario: dados.funcionario.id,          
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };       
        this.controlePontoService.marcarOcorrenciaExcluir(requisicao)
        .then(resp => {
          exibirMensagem(this, resp);
          let diaPonto = this.pontoOcorrenciaExcluir.dia;
          this.pontoOcorrenciaExcluir = null;
          this.exibirDialogExclurOcorrencias = false;
          this.calcularPeriodoEditado(diaPonto, diaPonto);   
          this.calcularPonto();                           
        })
        .catch(erro => {
          this.exibirDialogExclurOcorrencias = false;      
          exibirMensagem(this, erro);
        });
      },
      // espelhoPonto() {
      //   let dados = this.getDadosMarcacoes();              
      //   let requisicao = {
      //     mesSelecionado: this.mesAno.getMonth()+1,
      //     anoSelecionado: this.mesAno.getFullYear(),        
      //     idsFuncionarios: [dados.funcionario.id],         
      //     usuarioRequisicao: {...this.getDadosRequisicao()},          
      //   };       
      //   this.controlePontoService.espelhoPonto(requisicao)
      //   .then(resp => {     
      //     preViewArquivo(resp.data);             
      //   })
      //   .catch(erro => {
      //     if(erro.response.headers['ik-response']) {
      //       erro.response.data = JSON.parse(erro.response.headers['ik-response']);
      //     }
      //     exibirMensagem(this, erro)
      //   });
      // },
      espelhoPonto() {
        let dados = this.getDadosMarcacoes();      
        let requisicao = {
          mesSelecionado: this.mesAno.getMonth()+1,
          anoSelecionado: this.mesAno.getFullYear(),        
          idsFuncionarios: [dados.funcionario.id],             
          todos: false,   
          nomeDocumento: 'Espelho de Ponto',
          nomeArquivo: 'Espelho_Ponto',
          servico: 'espelhoPonto',
          tipoDocumento: 'pdf',   
          cnpj: dados.cnpj,
          usuarioRequisicao: {...this.getDadosRequisicao()},          
        };       
        this.controlePontoService.espelhoPonto(requisicao)
        .then(resp => {
          this.bloquearEnivo = true;
          this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramento(resp.data);                          
        })
        .catch(erro => { 
          exibirMensagem(this, erro);
        });
      },
      corDataDiaSemana(ponto) {
        let corCss = '';
        if(ponto.irregular) {
          corCss = '#C13928';//danger
        } else {
          corCss = "#1B8AED";//primary
        }       
        return '<span style="color: '+corCss+'">'+this.formatarStringData(ponto.dia)+' - '+ponto.diaDaSemana+'</span>';
      }, 
      corItensSumario(valor) {        
        if(valor.startsWith('-')) {
          return '<span style="color:#C13928">'+valor+'</span>';
        }else {          
          return valor;
        }
      },
      diaComPendencia(ponto) {
        return ponto.temPendencias ? 'p-text-bold' : '';
      },
      acoesPontoDia(ponto) {
        let acoes = [
          {label: 'Editar marcações', icon: 'pi pi-pencil', idPonto:ponto.id, command: (event) => {
              let requisicao = this.getRequisicao();              
              for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  requisicao['dataPonto'] = this.pontos[i].dia;
                  requisicao['idPonto'] = this.pontos[i].id;
                  break;
                }
              }  
              this.$refs.modalControleEditarMarcacoes.processar(requisicao);  
            }
          },
          {label: 'Justificar', icon: 'pi pi-check', idPonto:ponto.id, command: (event) => {
             let requisicao = this.getRequisicao();              
              for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  requisicao['dataPonto'] = this.pontos[i].dia;
                  requisicao['idPonto'] = this.pontos[i].id;
                  break;
                }
              }  
              this.$refs.modalControleJustificativa.processar(requisicao);  
            }
          },
          {label: 'Ajuste parcial', icon: 'pi pi-minus-circle', idPonto:ponto.id, command: (event) => {
              let requisicao = this.getRequisicao();              
              for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  requisicao['dataPonto'] = this.pontos[i].dia;
                  requisicao['idPonto'] = this.pontos[i].id;
                  break;
                }
              }  
              this.$refs.modalControleAjusteParcial.processar(requisicao);              
            }
          },
          {label: 'Excluir ocorrência', icon: 'pi pi-trash', idPonto:ponto.id, command: (event) => {
              for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  this.pontoOcorrenciaExcluir = this.pontos[i];
                  break;
                }
              } 
             this.exibirDialogExclurOcorrencias = true;
            }
          },
          {label: 'Folga', icon: 'pi pi-star', idPonto:ponto.id, command: (event) => {             
              let requisicao = this.getRequisicao();              
              for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  requisicao['data'] = this.pontos[i].dia;
                  break;
                }
              }  
              this.$refs.modalControleFolga.processar(requisicao);              
            }
          },
          {label: 'Mudança de horário', icon: 'pi pi-clock', idPonto:ponto.id, command: (event) => {
              let requisicao = this.getRequisicao();              
              for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  requisicao['dataPonto'] = this.pontos[i].dia;
                  requisicao['idPonto'] = this.pontos[i].id;
                  break;
                }
              }  
              this.$refs.modalControleMudancaHorario.processar(requisicao);               
            }
          },
          {label: 'Mover marcações', icon: 'pi pi-sort-alt', idPonto:ponto.id, command: (event) => {
             let requisicao = this.getRequisicao();
             requisicao['idPonto'] = event.item.idPonto;
             this.$refs.modalControleMoverMarcacao.processar(requisicao);
            }
          },
          {label: 'Feriado', icon: 'pi pi-star', idPonto:ponto.id, command: (event) => {
             let requisicao = this.getRequisicao();
             for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  requisicao['dataPonto'] = this.pontos[i].dia;                  
                  break;
                }
              }
             this.$refs.modalControleFeriadoExcluido.processar(requisicao);
            }
          },
          {label: 'Solicitações Pendentes', icon: 'pi pi-exclamation-circle', idPonto:ponto.id, command: (event) => {
             let requisicao = this.getRequisicao();
             for(let i = 0; i < this.pontos.length; i++) {
                if(this.pontos[i].id == event.item.idPonto) {
                  requisicao['dataPonto'] = this.pontos[i].dia;                  
                  break;
                }
              }
             this.$refs.solicitacoesPendentes.processar(requisicao);
            }
          },
        ]
        return acoes;
      },
      acoesGerais(periodoFechado) {
        if(periodoFechado) {
          this.maisAcoes = [
            {
              label: 'Abrir período',
              icon: 'pi pi-lock',
              command: () => {
                this.exibirDialogAbrirPeriodo = true;
              }
            },          
            {
              label: 'Espelho de ponto',
              icon: 'pi pi-print',
              command: () => {
                this.espelhoPonto();
              }
            },
          ];
        } else {
          this.maisAcoes = [
            {
              label: 'Calcular',
              icon: 'pi pi-refresh',
              command: () => {          
                if(this.dataUltimoCliqueCalc == null) {
                  this.atualizar();
                } else {
                  const timeClick = new Date().getTime();
                  const diffTimeClick = timeClick - this.dataUltimoCliqueCalc.getTime();
                  if(diffTimeClick >= this.intervaloMaxioCliqueCalc) {                 
                    this.atualizar();
                  }    
                } 
                this.dataUltimoCliqueCalc = new Date();                          
              }
            }, 
            {
              label: 'Fechar período',
              icon: 'pi pi-lock-open',
              command: () => {
                this.exibirDialogFecharPeriodo = true;
              }
            },          
            {
              label: 'Espelho de ponto',
              icon: 'pi pi-print',
              command: () => {
                this.espelhoPonto();
              }
            },
          ];
        }  
      },
      getRequisicao() {
        let dados = this.getDadosMarcacoes(); 
        let requisicao = {
          idFuncionario: dados.funcionario.id,
          funcionario: {...dados.funcionario},
          mes: this.mesAno.getMonth()+1,
          ano: this.mesAno.getFullYear(),           
          cnpj: {...dados.cnpj},
          usuarioRequisicao: {...this.getDadosRequisicao()},
        };
        return requisicao;
      },      
      criarRangeData() {
        let anoAtual = new Date().getFullYear();     
        this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
      },
      formatarStringData(data) {
        if(!data || data instanceof Date) {
          return '';
        } 
        let partes = data.split('-');
        return partes[2] + '/' + partes[1] + '/' + partes[0];
      },
      validarPermissoes() {		
        let permissoes = this.getPermissoes();
        this.permissaoEditar = permissoes.includes(127);
      }
  },
	created() {
    this.funcionarioService = new FuncionarioService();
    this.controlePontoService = new ControlePontoService();
    this.validarPermissoes();
    this.criarRangeData();	     
    this.iniciar();    
	},
  components: {
    'ControleFolga': ControleFolga,
    'ControleMoverMarcacao': ControleMoverMarcacao,
    'ControleJustificativa': ControleJustificativa,
    'ControleMudancaHorario': ControleMudancaHorario,
    'ControleAjusteParcial': ControleAjusteParcial,
    'ControleEditarMarcacoes': ControleEditarMarcacoes,
    'ControleFeriadoExcluido': ControleFeriadoExcluido,
    'SolicitacoesPendentes': SolicitacoesPendentes,
    'IKMonitoramentoDocumentos': IKMonitoramentoDocumentos
  }
}
</script>

<style> 
</style>